module.exports = __webpack_public_path__ + "img/img_10_technology_retail@3x.65934ca9.png";